document.addEventListener('DOMContentLoaded', function() {
  const burger = document.querySelector('.js-drawer-open-left'); // your hamburger button
  const sidebar = document.querySelector('#sidebar-nav-section'); // the sidebar
  const pageWrapper = document.querySelector('#page-wrapper');    // everything to move

  if (!burger) console.error('Hamburger button not found');
  if (!sidebar) console.error('Sidebar not found');
  if (!pageWrapper) console.error('Page wrapper not found');

  if (burger && sidebar && pageWrapper) {
    burger.addEventListener('click', function() {
      // Toggle sidebar visibility
      sidebar.classList.toggle('active');
      burger.classList.toggle('active');

      // Move the page wrapper to the right when sidebar is active
      if (sidebar.classList.contains('active')) {
        pageWrapper.style.transform = `translateX(${sidebar.offsetWidth}px)`;
      } else {
        pageWrapper.style.transform = 'translateX(0)';
      }
    });
  }
});
